import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetPendingInventoryTransferListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingTransferListingAttempt', handleGetPendingInventoryTransferListing, api);
}

function* handleGetPendingInventoryTransferListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            branchFrom,
            branchTo,
            dateFrom,
            dateTo,
        },
    } = reduxState.approval.pendingTransferListing;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetpendingTransferListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getInventoryTransferListing], {
        authToken,
        index,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchFrom: branchFrom ? Number(branchFrom) : undefined,
        branchTo: branchTo ? Number(branchTo) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetpendingTransferListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetpendingTransferListingSuccess(response.data));
    }
}
